export default __webpack_public_path__ + "static/media/kanban.main.bg.32de3b86.svg";